import React, { useMemo } from 'react';
import 'react-tooltip/dist/react-tooltip.css';
import styles from './styles.module.scss';
import { Menu } from './menu';
import { UserDashboard } from 'components/User/UserDashboard';
import { GlobalDialog } from './dialog/GlobalDialog';
import { UserProfileDialog } from '../../../../features/Dashboard/UserProfile/UserProfileDialog';
import { IUserProfile } from '../../../../features/Dashboard/UserProfile/UserProfileForm';
import userService from '../../../../store/user/service';
import { getAccessToken } from 'functions/localStorage';
import { WebSocketClientWrapper } from 'contexts/webSocketClient';
import { useManager } from '../../../../contexts/access/ManagerContext/useManager';

type IProps = {
  children: JSX.Element;
  user: IUserProfile;
  profileOpen: boolean;
  setProfileOpen: (e: boolean) => void;
};

export const DashboardLayout = ({
  children,
  user,
  profileOpen,
  setProfileOpen,
}: IProps) => {
  const [updateUser] = userService.endpoints.updateUser.useMutation();
  const token = useMemo(() => getAccessToken(), []);
  const { isReadOnly } = useManager();

  return (
    <WebSocketClientWrapper sessionToken={token}>
      <GlobalDialog>
        <div className={styles.root}>
          <nav>
            <Menu />
            {user && (
              <div>
                <div onClick={() => setProfileOpen(true)}>
                  <UserDashboard
                    {...{
                      name: `${user.firstName} ${user.lastName}`,
                      avatar: user.avatar,
                      role: isReadOnly ? 'Read Only' : 'Compliance Manager', // TODO: refactor
                    }}
                  />
                </div>
                {user ? (
                  <UserProfileDialog
                    user={user}
                    open={profileOpen}
                    setOpen={setProfileOpen}
                    onSubmit={(e) => {
                      setProfileOpen(false);
                      updateUser(e);
                    }}
                  />
                ) : null}
              </div>
            )}
          </nav>
          <section>{children}</section>
        </div>
      </GlobalDialog>
    </WebSocketClientWrapper>
  );
};
